import * as React from 'react'

function IconOpen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={39}
      height={39}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={19.5} cy={19.5} r={19.5} fill="#fff" />
      <path
        d="M28.126 16.927l-6.35 11.15a2.564 2.564 0 01-4.471 0l-6.348-11.15C9.963 15.18 11.207 13 13.194 13h12.698c1.988 0 3.228 2.18 2.234 3.927z"
        fill="#0078B6"
      />
    </svg>
  )
}

export default IconOpen
